var map = {
	"./00.jpg": 2247,
	"./01.jpg": 2248,
	"./02.jpg": 2249,
	"./Harry's Wand - Img - Wip 2_00.jpg": 2250,
	"./Harry's Wand - Img - Wip 2_01.jpg": 2251,
	"./Harry's Wand - Img - Wip 2_02.jpg": 2252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2246;